import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { router } from '@/app/router'
import { ThemeProvider } from '@/shared/lib/theme'
import { ThemeTokens } from '@/features/site/ThemeTokens'
import { ApiError } from '@/shared/api/client'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Повторять запрос при 4xx бессмысленно: ответ не изменится.
        if (error instanceof ApiError && error.status < 500) return false
        return failureCount < 2
      },
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        {/* Токены оформления приходят с сервера: смена темы и откат не
            требуют новой сборки (ТЗ §22). */}
        <ThemeTokens />
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>
  )
}
